import React from 'react';

/**
 * Brand mark: airplane silhouette orbiting a clock face.
 * Communicates "right time × flight" — exactly what the predictor solves.
 *
 * Renders a sharp, editorial monogram with two-tone strokes.
 *  - sizes: number (px) for square mark
 *  - tone: "default" (blue+amber) | "mono" (single color)
 */
export default function AppLogo({ size = 40, tone = 'default', className = '' }) {
  const primary = tone === 'mono' ? 'currentColor' : '#1d4ed8'; // deeper blue
  const accent = tone === 'mono' ? 'currentColor' : '#f59e0b'; // amber

  return (
    <span
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Soft halo */}
        <circle cx="32" cy="32" r="29" fill="#eff6ff" />

        {/* Clock dial */}
        <circle
          cx="32"
          cy="32"
          r="20"
          stroke={primary}
          strokeWidth="2.25"
          fill="#ffffff"
        />

        {/* Hour ticks (12, 3, 6, 9) */}
        <g stroke={primary} strokeWidth="2" strokeLinecap="round">
          <line x1="32" y1="14" x2="32" y2="17" />
          <line x1="50" y1="32" x2="47" y2="32" />
          <line x1="32" y1="50" x2="32" y2="47" />
          <line x1="14" y1="32" x2="17" y2="32" />
        </g>

        {/* Clock hands (pointing 10:10 — friendly travel reading) */}
        <line
          x1="32"
          y1="32"
          x2="24"
          y2="24"
          stroke={primary}
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <line
          x1="32"
          y1="32"
          x2="40"
          y2="26"
          stroke={primary}
          strokeWidth="2.5"
          strokeLinecap="round"
        />

        {/* Center pin */}
        <circle cx="32" cy="32" r="2.2" fill={primary} />

        {/* Airplane sweeping over the dial — diagonal trajectory */}
        <g transform="rotate(-25 32 32)">
          {/* Trail dots */}
          <circle cx="14" cy="50" r="1.2" fill={accent} opacity="0.55" />
          <circle cx="17" cy="48" r="1.4" fill={accent} opacity="0.75" />
          <circle cx="20" cy="46" r="1.6" fill={accent} opacity="0.9" />

          {/* Plane body */}
          <path
            d="M51 21 L46 26 L36 24 L31 30 L37 33 L33 38 L37 39 L41 35 L48 35 L53 30 L57 24 Z"
            fill={accent}
            stroke="#b45309"
            strokeWidth="0.6"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </span>
  );
}
